<!-- ══════════════════════════════════════════════════════════════════ -->
<!-- COMMAND PALETTE / SPOTLIGHT MODAL (⌘K)                             -->
<!-- ══════════════════════════════════════════════════════════════════ -->
@if (isSpotlightOpen) {
  <div
    class="c-spotlight-backdrop"
    (click)="onBackdropClick()"
    role="dialog"
    aria-modal="true"
    aria-label="Command Palette Spotlight"
  >
    <div class="c-spotlight" cdkTrapFocus cdkTrapFocusAutoCapture (click)="$event.stopPropagation()">
      <!-- SEARCH HEADER -->
      <div class="c-spotlight__header">
        <mat-icon class="c-spotlight__search-icon" aria-hidden="true">search</mat-icon>
        <input
          #searchInput
          id="spotlightSearchInput"
          name="spotlightSearch"
          type="text"
          aria-label="Buscar módulos WFM"
          class="c-spotlight__input"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          placeholder="Buscar módulos: planejamento de escala, operações, funcionários, ponto…"
          autocomplete="off"
          spellcheck="false"
        />
        <div class="c-spotlight__header-badges">
          @if (searchQuery) {
            <button
              type="button"
              class="c-spotlight__clear-btn"
              (click)="clearSearch()"
              title="Limpar busca"
              aria-label="Limpar busca"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
          <button type="button" class="c-spotlight__esc-badge" (click)="closeSpotlight()" title="Pressione ESC para fechar" aria-label="Fechar busca">ESC</button>
        </div>
      </div>

      <!-- SPOTLIGHT BODY / SECTIONS & RESULTS -->
      <div class="c-spotlight__body" #spotlightBody (mousemove)="onMouseMove($event)">
        @if (filteredSections.length > 0) {
          @for (section of filteredSections; track section.id) {
            <div class="c-spotlight__section">
              <div class="c-spotlight__section-header">
                <mat-icon class="c-spotlight__section-icon">{{ section.icon }}</mat-icon>
                <span class="c-spotlight__section-title">{{ section.title }}</span>
                <span class="c-spotlight__section-count">{{ section.items.length }}</span>
              </div>
              <div class="c-spotlight__items-group">
                @for (item of section.items; track item.id) {
                  <div
                    class="c-spotlight__item"
                    [class.c-spotlight__item--selected]="isItemSelected(item)"
                    [class.c-spotlight__item--active-route]="isCurrentRoute(item.route)"
                    [class.c-spotlight__item--primary]="item.isPrimary"
                    (click)="executeItem(item)"
                    (mouseenter)="onItemMouseEnter(item)"
                  >
                    <div
                      class="c-spotlight__item-icon-wrapper"
                      [class.c-spotlight__item-icon-wrapper--primary]="item.isPrimary"
                    >
                      <mat-icon class="c-spotlight__item-icon">{{ item.icon }}</mat-icon>
                    </div>
                    <div class="c-spotlight__item-content">
                      <div class="c-spotlight__item-title-row">
                        <span class="c-spotlight__item-title">{{ item.title }}</span>
                        @if (item.isPrimary) {
                          <span class="c-spotlight__badge-primary">Destaque WFM</span>
                        }
                        @if (isCurrentRoute(item.route)) {
                          <span class="c-spotlight__badge-active">
                            <span class="c-spotlight__badge-dot"></span> Atual
                          </span>
                        }
                      </div>
                      @if (item.subtitle) {
                        <span class="c-spotlight__item-subtitle">{{ item.subtitle }}</span>
                      }
                    </div>
                    <div class="c-spotlight__item-end">
                      @if (isItemSelected(item)) {
                        <span class="c-spotlight__item-enter-hint">
                          <span>Abrir</span>
                          <span class="c-spotlight__kbd-small">↵</span>
                        </span>
                      } @else {
                        <mat-icon class="c-spotlight__item-arrow">chevron_right</mat-icon>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        } @else {
          <div class="c-spotlight__empty">
            <div class="c-spotlight__empty-icon-wrap">
              <mat-icon class="c-spotlight__empty-icon">search_off</mat-icon>
            </div>
            <h4 class="c-spotlight__empty-title">Nenhum módulo encontrado</h4>
            <p class="c-spotlight__empty-desc">
              Não encontramos resultados para "<strong>{{ searchQuery }}</strong>".<br />
              Tente buscar por termos como <em>escala, turnos, operações, férias, ponto, relatórios</em>...
            </p>
          </div>
        }
      </div>

      <!-- SPOTLIGHT FOOTER -->
      <div class="c-spotlight__footer">
        <div class="c-spotlight__footer-hints">
          <span class="c-spotlight__hint-item"> <kbd>↑</kbd><kbd>↓</kbd> Navegar </span>
          <span class="c-spotlight__hint-item"> <kbd>↵</kbd> Selecionar </span>
          <span class="c-spotlight__hint-item"> <kbd>ESC</kbd> Fechar </span>
        </div>
        <div class="c-spotlight__footer-brand">
          <span class="c-spotlight__brand-m">M</span>
          <span class="c-spotlight__brand-text">Grupo Madero Workforce</span>
        </div>
      </div>
    </div>
  </div>
}
